import { ArrowRight } from "@phosphor-icons/react";
import { formatINR } from "../../lib/format";
import { cn as classJoin } from "../../lib/utils";
import { STAGE_VISUAL } from "./constants";

export default function FunnelStage({ stage, isFirst, valueWidthPct }) {
    const v = STAGE_VISUAL[stage.key] || STAGE_VISUAL.proposal;
    const Icon = v.Icon;
    return (
        <div className="reedos-card overflow-hidden" data-testid={`funnel-stage-${stage.key}`}>
            <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between gap-2">
                <div className="flex items-center gap-2.5">
                    <div className={classJoin("h-9 w-9 rounded-md bg-gradient-to-br text-white flex items-center justify-center shadow-sm", v.color)}>
                        <Icon size={16} weight="fill" />
                    </div>
                    <div>
                        <div className="reedos-eyebrow text-[9px]">{stage.label}</div>
                        <div className="font-display font-bold text-2xl reedos-data leading-none mt-0.5">{stage.count}</div>
                    </div>
                </div>
                <div className="text-right">
                    <div className="reedos-eyebrow text-[9px]">Value</div>
                    <div className="reedos-data text-sm font-bold text-slate-900">{formatINR(stage.value)}</div>
                </div>
            </div>
            <div className="px-4 py-2.5 bg-slate-50/50 space-y-1.5">
                <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                    <div className={classJoin("h-full bg-gradient-to-r rounded-full", v.color)} style={{ width: `${Math.max(2, valueWidthPct)}%` }} />
                </div>
                <div className="flex items-center justify-between text-[10px] font-semibold">
                    {!isFirst && stage.conversion_pct_from_prev !== null && (
                        <span className={classJoin("inline-flex items-center gap-0.5",
                            stage.conversion_pct_from_prev >= 60 ? "text-emerald-700" :
                                stage.conversion_pct_from_prev >= 30 ? "text-amber-700" : "text-rose-700")}
                            data-testid={`funnel-stage-${stage.key}-conv-prev`}>
                            <ArrowRight size={10} weight="bold" /> {stage.conversion_pct_from_prev}% from prev
                        </span>
                    )}
                    {isFirst && <span className="text-slate-400">Top of funnel</span>}
                    <span className="text-slate-500" data-testid={`funnel-stage-${stage.key}-conv-top`}>
                        {stage.conversion_pct_from_top}% of top
                    </span>
                </div>
            </div>
        </div>
    );
}
